import React from 'react';
import { Navigate } from 'react-router-dom';
import { Server } from '../../server/server';
import AlertModal from '../modals/AlertModal';
import MessageModal from '../modals/MessageModal';
import QuestionModal from '../modals/QuestionModal';
import PageEnvelope from '../elements/PageEnvelope';
import ContentPanel from '../elements/ContentPanel';
import PostPanel from '../elements/PostPanel';
import PageHeader from '../elements/PageHeader';
import './SitePage.css'

interface BlogPageState {
  blog: any;
  message: string;
  alert: string;
  question: string;
  navigate: string;
  date: string;
}

class BlogPage extends React.Component<{}, BlogPageState> {
  constructor(props: any) {
    super(props);
    this.state = {
      blog: null,
      message: '',
      alert: '',
      question: '',
      navigate: '',
      date: ''
    }
  }

  componentDidMount() {
    this.getBlog();
  }

  async getBlog() {
    let slug = window.location.pathname.substring(6);

    let response = await Server.blogs.getBlog({slug});
    if (!response.success)
      return

    // cache profile of blog author
    let profiles = [];
    let blog = response.blog;
    profiles.push(blog.author);

    // cache profile of comments user
    let comments = blog.comments;
    for (let i = 0; i < comments.length; i++) {
      if(profiles.indexOf(comments[i].user) == -1)
        profiles.push(comments[i].user);
    }

    await Server.public.loadProfiles(profiles);
    this.setState({blog: blog});
  }

  async onCreateComment(content:string) {
    let params = {
      id: this.state.blog.id,
      content: content
    };

    this.setState({message: 'Commenting...'});

    let response = await Server.blogs.createComment(params);

    if (response.success) {
      this.setState({message: ''});
    }
    else
      this.setState({message: '', alert: response.message})

    // add new comment to cache
    let newComment = {
      user: Server.user.getId(),
      content: content,
      date: response.date
    };
    
    this.state.blog.comments.unshift(newComment);

    this.forceUpdate();
  }

  onDeleteComment(date:string) {
    this.setState({question: 'Are you sure you want to delete this comment?', date});
  }

  onDeleteCommentYes() {
    this.setState({question: '', message: 'Deleting comment...'});

    setTimeout(async () => {
      let params = {
        id: this.state.blog.id,
        date: this.state.date
      };

      let response = await Server.blogs.deleteComment(params);

      if (response.success) {
        // update to cache
        let comments = this.state.blog.comments;
        for(let i = 0; i < comments.length; i++) 
          if(comments[i].date == this.state.date && comments[i].user == Server.user.getId())
            comments.splice(i, 1);

        this.setState({message: ''});
      }
      else
        this.setState({message: '', alert: response.message})
    }, 500);
  }

  onEditBlog() {
    this.setState({navigate: '/blog/edit/' + this.state.blog.slug})
  }

  renderComments() {
    let divs = [];

    for (let i = 0; i < this.state.blog.comments.length; i++) {
      let comment = this.state.blog.comments[i];
      let action = comment.user == Server.user.getId() ? 'delete' : '';

      divs.push(
        <ContentPanel 
          author={comment.user}
          date={comment.date}
          content={comment.content}
          reply={true}
          action={action}
          onAction={()=>this.onDeleteComment(comment.date)}
        />
      )
    }

    return divs;
  }

  render() {
    if(this.state.navigate != '') 
      return <Navigate to={this.state.navigate} />;

    let blog = this.state.blog;
    if (!blog) {
      return (
        <div className="site-page">
          <PageEnvelope width="600px">
            <PageHeader text="Loading..." navigate="/blogs" />
          </PageEnvelope>
        </div>
      )
    }

    let action = (blog.author == Server.user.getId()) ? 'edit' : ''

    return (
      <div className="site-page">
        <PageEnvelope width="600px">
          <div className="site-page-column">

            <PageHeader text="View Blog" navigate="/blogs">
              <div style={{textAlign: 'right', whiteSpace: 'nowrap'}}>
                <a href='#blog-comments' style={{fontSize: '0.9em', color: 'var(--header-panel-color)'}}>
                  {blog.comments.length} Comments
                </a>
              </div>
            </PageHeader>

            <ContentPanel
              author={blog.author}
              date={blog.date}
              title={blog.title}
              content={blog.content}
              action={action}
              onAction={()=>this.onEditBlog()}
            />

            <PostPanel 
              placeholder="Enter comment..."
              onPost={(content:string)=>this.onCreateComment(content)}
            />

            {this.state.blog.comments.length > 0 &&
              <div className="site-page-header">
                {this.state.blog.comments.length} Comments
              </div>
            }

            {this.renderComments()}
          </div>
        </PageEnvelope>

        <MessageModal message={this.state.message} />
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})}/>
        <QuestionModal 
          message={this.state.question} 
          onYes={()=>this.onDeleteCommentYes()} 
          onNo={()=>this.setState({question: ''})} 
        />
      </div>
    )
  }
}

export default BlogPage;